import { useUserStore } from "../store";
const useIsLoggedIn = () => useUserStore((state) => state.isLoggedIn);

export default useIsLoggedIn;
